<div class="p-4">
  <h5 class="f-14 title-color">{{ modalTitle }}</h5>
  <span class="f-12 subtitle-color">{{ modalSubtitle }}</span>
  <hr />
  <div *ngFor="let jobboard of mappedFreeJobboardState">
      <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
              <img height="32" class="mr-2" [src]="jobboard.logo" alt="jobboard logo">
              <div>
                  <h6 class="f-14 boardname-color">{{ jobboard.name }}</h6>
                  <span class="f-12 subtitle-color">{{ jobboard.description }}</span>
              </div>
          </div>
          <div class="d-flex align-items-center">
              <div *ngIf="jobboard.loading" class="mr-2">
                  <i class="fas fa-spinner fa-spin"></i>
              </div>
              <div class="custom-control custom-switch" placement="left" tooltipClass="f-10" [disableTooltip]="disableTooltipCareer(jobboard.name)" [ngbTooltip]="getToolTip(jobboard.name)">
                  <input data-testid="auto-jobboards-input-1" [disabled]="jobboard.name == 'Career site' || jobboard.name == 'Indeed'" (change)="updateJobboardStatus(jobboard.jobboardid, $event.target.checked)" type="checkbox" class="custom-control-input" [id]="jobboard.name" checked>
                  <label class="custom-control-label" [for]="jobboard.name">&nbsp;</label>
              </div>
          </div>
      </div>
      <hr />
  </div>
  <div class="d-flex justify-content-between align-items-center">
      <div>
          <div *ngIf="errorState !== null">
              <i class="fas fa-exclamation-circle mr-1 text-red-e94"></i>
              <span class="text-red-e94">{{ errorState }}</span>
          </div>
      </div>
      <div class="d-flex">
          <button data-testid="auto-jobboards-button-1" (click)="cancelProcess()" class="btn-trms-white">{{ cancelText }}</button>
          <!-- <button data-testid="auto-jobboards-button-2" (click)="okProcess()" class="bg-blue wc-btn ml-2">{{ okText }}</button> -->
      </div>
  </div>
</div>